import { useState } from 'react';
import { ThemeSelector } from './ThemeSelector';
import { WorkspaceLayoutSelector } from './WorkspaceLayoutSelector';
import { SettingsModal } from './SettingsModal';
import { useDAWStore } from '../store/daw-store';

export function TopMenuBar() {
  const [isThemeSelectorOpen, setIsThemeSelectorOpen] = useState(false);
  const [isLayoutSelectorOpen, setIsLayoutSelectorOpen] = useState(false);
  const [isOptionsMenuOpen, setIsOptionsMenuOpen] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);
  const reduceMotion = useDAWStore((state) => state.reduceMotion);
  const setReduceMotion = useDAWStore((state) => state.setReduceMotion);
  const menuItems = ['FILE', 'EDIT', 'ADD', 'PATTERNS', 'VIEW', 'OPTIONS', 'TOOLS', 'HELP'];

  const handleMenuClick = (item: string) => {
    if (item === 'OPTIONS') {
      setIsOptionsMenuOpen(!isOptionsMenuOpen);
    }
  };

  const handleThemeClick = () => {
    setIsThemeSelectorOpen(true);
    setIsOptionsMenuOpen(false);
  };

  const handleLayoutClick = () => {
    setIsLayoutSelectorOpen(true);
    setIsOptionsMenuOpen(false);
  };

  const handleSettingsClick = () => {
    setIsSettingsOpen(true);
    setIsOptionsMenuOpen(false);
  };

  return (
    <>
      <div className="bg-[#0f0f0f] h-6 flex items-center px-2 text-xs border-b border-[#3a3a3a] relative">
        {menuItems.map((item) => (
          <div key={item} className="relative">
            <button
              onClick={() => handleMenuClick(item)}
              className="px-3 py-1 hover:bg-[#2a2a2a] transition-colors"
            >
              {item}
            </button>
            
            {/* Options Dropdown Menu */}
            {item === 'OPTIONS' && isOptionsMenuOpen && (
              <div className="absolute top-full left-0 mt-0 bg-[#1a1a1a] border border-[#3a3a3a] rounded shadow-lg z-50 min-w-[180px]">
                <button
                  onClick={handleThemeClick}
                  className="w-full text-left px-4 py-2 hover:bg-[#2a2a2a] transition-colors text-sm"
                >
                  Theme...
                </button>
                <button
                  onClick={handleLayoutClick}
                  className="w-full text-left px-4 py-2 hover:bg-[#2a2a2a] transition-colors text-sm"
                >
                  Workspace Layout...
                </button>
                <div className="border-t border-[#3a3a3a] my-1" />
                <button
                  onClick={handleSettingsClick}
                  className="w-full text-left px-4 py-2 hover:bg-[#2a2a2a] transition-colors text-sm"
                >
                  Settings...
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Close options menu when clicking outside */}
      {isOptionsMenuOpen && (
        <div 
          className="fixed inset-0 z-40" 
          onClick={() => setIsOptionsMenuOpen(false)}
        />
      )}

      <ThemeSelector 
        isOpen={isThemeSelectorOpen} 
        onClose={() => setIsThemeSelectorOpen(false)} 
      />
      
      <WorkspaceLayoutSelector
        isOpen={isLayoutSelectorOpen}
        onClose={() => setIsLayoutSelectorOpen(false)}
      />
      
      {isSettingsOpen && (
        <SettingsModal onClose={() => setIsSettingsOpen(false)} />
      )}
    </>
  );
}
